import styled from 'styled-components';
const TablePageStyled = styled.div`
  .export-wrapper {
    margin: 16px 0;
    padding-left: 32px;
    height: 34px;
    .export {
      width: 107px;
      color: #fff;
      .MuiSvgIcon-root {
        margin-right: 8px;
      }
    }
  }
`;
export default TablePageStyled;
